import React, { Component } from 'react'

export default class downloadBlue extends Component {
    render() {
        return (

            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="none" viewBox="0 0 21 21">
                <path stroke="#1F36C7" stroke-linecap="round" strokeLinejoin="round" strokeWidth="1.6" d="M18.496 13.135v3.334c0 .442-.175.865-.488 1.178-.313.313-.736.488-1.179.488H5.163c-.442 0-.866-.175-1.179-.488-.312-.313-.488-.736-.488-1.178v-3.334M6.832 8.967l4.167 4.167 4.166-4.167M10.996 13.135v-10" />
            </svg>

        )
    }
}
